@if (rss(); as view) {
  <span>{{ 'Average RSS' | translate }} {{ view.average }}</span>
  <span>{{ 'Minimum RSS' | translate }} {{ view.minimum }}</span>
  <span>{{ 'Maximum RSS' | translate }} {{ view.maximum }}</span>
} @else {
  <span>—</span>
}
